import { Component, ErrorInfo, ReactNode } from "react"

// AI-WINDOW-READD 2026-07-03: dedicated error boundary for the CooweAI side-window mount.
// The window-shell wrapper previously broke login when it wrapped the auth transition (see
// commit 1c848a1e). This time the shell only mounts once the app is already fully settled
// (see isAppSettled in App.js), and this boundary is the second line of defense: if the
// CooweAI panel (or the shell markup around it) throws for any reason, it degrades to
// rendering nothing -- never a white screen, never an auth bounce.
interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
}

class AIPanelErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.warn("[AIPanelErrorBoundary] CooweAI panel crashed, rendering nothing", error, info)
  }

  render() {
    if (this.state.hasError) {
      return null
    }

    return this.props.children
  }
}

export default AIPanelErrorBoundary
